// extracted by mini-css-extract-plugin
module.exports = {"productPromotionCountdown":"ProductPromotionCountdown_productPromotionCountdown__6qhci","headline":"ProductPromotionCountdown_headline__afDpv"};